var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsCc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2177_2343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1011 58.146C51.3803 61.3758 50.6166 64.492 46.9509 64.9946L4.25645 65C2.02824 64.7856 0.194509 63.1501 0.00177002 60.8876V4.24567C0.109848 1.95081 2.00302 0.176528 4.25645 0L34.0572 0.0648469L50.8021 16.6566L51.0759 17.3285L51.139 29.2658L62.8726 36.0278L63.4328 36.5484C64.1696 45.6522 58.9152 53.8517 51.1029 58.146H51.1011ZM32.9692 1.62297H3.99166C3.94482 1.62297 3.24231 1.91298 3.12703 1.97243C2.31825 2.39213 1.66798 3.3252 1.62294 4.24567V60.7525C1.74183 62.2098 2.95771 63.2798 4.39154 63.3824H46.6879C49.5484 63.06 49.6078 60.5454 49.4547 58.2127C43.5248 54.6984 38.9045 49.5034 37.5175 42.59C37.2977 41.493 36.6817 37.2419 37.1482 36.4674L49.4511 29.1955V18.0725H33.3079C33.2844 18.0725 32.9692 17.759 32.9692 17.7356V1.62297ZM48.2353 16.4549L34.5904 2.83705V16.4549H48.2353ZM50.3284 30.66L38.7118 37.3554C38.2416 45.6054 43.1988 52.8232 50.2149 56.7446C56.0547 53.5707 60.4373 48.2137 61.5703 41.5633C61.7018 40.7905 62.1341 37.7607 61.7432 37.2888L50.3284 30.66Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06983 23.2224L42.4999 23.1899L43.2349 23.4007C43.7608 24.0852 43.188 24.8688 42.3648 24.8219H8.71289C7.74379 24.8453 7.12054 23.8114 8.06983 23.2242V23.2224Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20672 29.5612L41.5542 29.527C42.898 29.5108 42.8908 31.177 41.5542 31.1572H8.57779C7.43757 31.1535 7.26824 30.1052 8.20672 29.5612Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06983 55.1775L42.2351 55.273C42.8278 55.9773 42.3144 56.8077 41.4191 56.7752H8.71289C7.74379 56.7987 7.12054 55.7647 8.06983 55.1775Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34362 48.7091L36.824 48.6766C37.9426 48.6928 38.0525 50.1663 36.9627 50.305H8.30759C7.88609 50.3158 7.64291 49.9375 7.58167 49.5557C7.6357 49.145 7.94913 48.8153 8.34362 48.7073V48.7091Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20856 42.3721L34.6607 42.3414C35.8117 42.3883 35.7054 43.8329 34.6661 43.968L8.44813 43.9626C7.48443 43.9806 7.24846 42.5936 8.20856 42.3721Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06984 36.0314L34.259 35.999C35.4118 36.1485 34.9038 37.84 33.7168 37.6292H8.84981C7.83027 37.6688 7.05211 36.7249 8.06984 36.0314Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06982 13.7835L26.1531 13.7511C27.2627 13.8934 27.0664 15.3597 26.0144 15.3795H8.58139C7.66093 15.3056 7.17998 14.3221 8.06982 13.7853V13.7835Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06982 7.98701L26.1531 7.95459C27.3221 8.1041 27.0357 9.65322 25.8757 9.57936L8.58139 9.58297C7.66093 9.50911 7.17998 8.5238 8.06982 7.98881V7.98701Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6944 35.7775C60.0446 35.0029 61.2713 50.7679 51.0039 51.6452C40.423 52.5494 39.2252 36.5611 49.6944 35.7775ZM49.8295 37.3933C41.5056 38.0129 42.3829 50.7373 50.8688 50.0258C59.0233 49.3413 58.0434 36.7808 49.8295 37.3933Z",
    fill: "#63C4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6858 40.4896C55.1019 40.8841 54.938 41.4893 54.5849 41.8694L49.3251 46.9995L48.4317 46.9311C47.9453 46.2232 45.5117 44.4381 45.6036 43.6707C45.6667 43.1429 46.1854 42.8115 46.6862 43.0006C47.2194 43.2024 48.8225 45.1694 48.9811 45.1694L53.7023 40.4446C53.9328 40.2338 54.4786 40.2879 54.6876 40.4878L54.6858 40.4896Z",
    fill: "#63C4AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2177_2343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.4995,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsCc2);
export default __webpack_public_path__ + "static/media/as-cc-2.242647a7fce56d28d70cd4239cd33926.svg";
export { ForwardRef as ReactComponent };